import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react';

import ExpertIntegrationContainerHeader from '../ExpertIntegrationContainerHeader';
import { FolderUpload } from '@/client/components/icons/ContinuIcons';
import LocalUploadFileList from './LocalUploadFileList';
import { useTranslation } from 'react-i18next';

interface LocalUploadFileListModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Callback function to close the modal */
  onClose: () => void;
}

export default function LocalUploadFileListModal({
  isOpen,
  onClose,
}: LocalUploadFileListModalProps) {
  const { t } = useTranslation();

  return (
    <Modal size="3xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent padding={6} paddingTop={10}>
        <ModalCloseButton />

        <ModalBody>
          <Stack spacing={8}>
            <ExpertIntegrationContainerHeader
              integrationName={`${t('admin.aiAgent.experts.form.integrations.localUpload.title')}`}
              integrationDescription={`${t(
                'admin.aiAgent.experts.form.integrations.localUpload.helpText',
              )}`}
              integrationIcon={<FolderUpload color="#627FFF" boxSize={8} />}
              handleOnSetupButtonClick={() => {}}
            />

            <LocalUploadFileList />
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
